import { Box } from "@mui/material";
import { Children } from "react";

import styles from "./step-box.module.scss";

type Props = {
  children: React.ReactNode;
};

export default function StepBox(props: Readonly<Props>) {
  const { children } = props;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        py: 4,
        my: 4,
        borderTop: "1px solid #eee",
        marginBottom: 0,
        paddingBottom: 0,
      }}
      className={styles.box}
    >
      {Children.count(children) === 1 ? <div /> : null}
      {children}
    </Box>
  );
}
